<template>
    <div class="mt-2" ref="loader">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="col-7 text-start"> <!-- col 7 fixes the german Servicegruppen to be in one line -->
                    <h5><i class="fa-solid fa-chevron-left" @click="goBack"></i> <i
                        class="fas fa-person-chalkboard"></i> {{ $t('Resources') }}</h5>
                </b-col>
                <b-col class="text-end">
                    <button type="button" class="btn btn-light btn-sm rounded" @click="reset()">
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                </b-col>
            </b-row>
            <b-list-group class="mt-3">
                <b-list-group-item>
                    <b-button class="w-100" variant="primary" @click="toggleFilterForm()">
                        Filter
                    </b-button>
                    <b-collapse id="status" v-model="toggleFilter">
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="listFilter.filter.name" :placeholder="$t('Name')"></b-form-input>
                        </div>
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="listFilter.filter.description"
                                          :placeholder="$t('description')"></b-form-input>
                        </div>
                        <div class="d-flex w-100 mt-2">
                            <multiselect v-model="stateFilter"
                                         track-by="value"
                                         :multiple="true"
                                         :close-on-select="true"
                                         :show-labels="false"
                                         label="label"
                                         placeholder="Resource status"
                                         :options="stateFilterOptions"
                                         :searchable="false"
                                         :allow-empty="true">
                            </multiselect>
                        </div>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>

            <b-list-group class="mt-3 mb-3">
                <b-list-group-item v-if="selected">
                    <b-button class="w-100" variant="primary" @click="toggleStateForm()">
                        <i class="fa-solid fa-person-chalkboard"></i> {{ $t('Set status for selected resources') }}
                    </b-button>
                    <b-collapse id="status" v-model="collapseStateForm">
                        <div class="row alert alert-warning alert-dismissible fade show m-0 mt-1"
                             v-show="!selected">
                            <div class="col-lg-12">
                                <div class="d-flex align-items-center">
                                    <div class="flex-1">
                                        <span class="h6">
                                            {{ $t('warning') }}
                                        </span>
                                        <br>
                                        {{ $t('No items are selected for status!') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row alert alert-danger alert-dismissible fade show m-0 mt-1"
                             v-show="containNotAssignedObjects">
                            <div class="col-lg-12">
                                <div class="d-flex align-items-center">
                                    <div class="flex-1">
                                        <span class="h6">
                                            {{ $t('attention') }}
                                        </span>
                                        <br>
                                        {{ $t('The list contains resources that are not assigned to you!') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                {{ $t('Do you want set status for the selected objects?') }}
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 m-0 mt-1">
                                <ul>
                                    <li v-for="object in massSelections" class="word-break">
                                        <span
                                            :class="{'text-decoration-line-through': !object.my_resource && settings.require_user_assigment || !object.is_expired && !settings.allow_overwriting}">
                                            {{ object.name }}
                                        </span>
                                        <ul>
                                            <li v-if="!object.my_resource">
                                                <span class="text-danger pl-2">
                                                    <i class="far fa-bell-slash"></i>
                                                    {{ $t('Not assigned to you') }}
                                                </span>
                                            </li>
                                            <li v-if="!object.is_expired && !settings.allow_overwriting">
                                                <span class="text-danger pl-2">
                                                    <i class="fas fa-person-chalkboard"></i>
                                                    {{ $t('Status has already been set') }}
                                                </span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <ul class="m-0 list-unstyled mb-3">
                                    <li v-if="!settings.allow_overwriting">
                                        ⚠️
                                        {{ $t('Resources, where a status has already been submitted will be ignored') }}
                                    </li>
                                    <li v-if="settings.require_user_assigment">
                                        ⚠️ {{ $t('Resources where  you are not assigend to will be ignored') }}
                                    </li>
                                </ul>
                                <div class="form-group required">
                                    <label class="control-label">
                                        {{ $t('status') }}
                                    </label>
                                    <multiselect v-model="state"
                                                 track-by="value"
                                                 :multiple="false"
                                                 :close-on-select="true"
                                                 :show-labels="false"
                                                 label="label"
                                                 placeholder="status"
                                                 :options="stateOptions"
                                                 :searchable="false"
                                                 :allow-empty="false">
                                    </multiselect>
                                </div>
                                <small class="text-danger" v-if="error.status">
                                    {{ $t('This cannot be left empty') }}
                                </small>
                                <div class="form-group" :class="{'required': state.value > 1}">
                                    <label class="control-label" for="comment">
                                        {{ $t('comment') }}
                                    </label>
                                    <textarea class="form-control" rows="4" id="comment" name="comment"
                                              :class="{'is-invalid': comment && comment.length > 1024}"
                                              placeholder='Add comment'
                                              v-model="comment">
                                    </textarea>
                                    <small>{{ $t('The maximum length of this field is 1024 characters.') }}
                                    </small>
                                    <div><small v-if="comment">
                                        {{ $t('Remaining characters') }}
                                        <code>
                                            {{ ( 1024 - comment.length ) < 0 ? 0 : 1024 - comment.length }}
                                        </code>
                                    </small></div>


                                    <small class="text-danger" v-if="error.comment">
                                        {{ $t('This cannot be left empty') }}
                                    </small>
                                </div>
                                <div class="row mt-3">
                                    <b-col class="text-end">
                                        <button type="button" class="btn btn-primary btn-sm rounded"
                                                @click="setState()">
                                            {{ $t('Set Status') }}
                                        </button>
                                    </b-col>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </b-collapse>
                </b-list-group-item>
                <b-list-group-item class="p-0"
                                   v-if="permissions.scmmodule && permissions.scmmodule.resources && permissions.scmmodule.resources.setstatus">
                    <b-button-group class="d-flex">
                        <b-button @click="selectAll" variant="primary">
                            <i class="fa-regular fa-square-check"></i>
                            {{ $t('select-all') }}
                            <b-badge pill variant="light" v-show="massSelections.length > 0"> {{
                                    massSelections.length
                                }}
                            </b-badge>
                        </b-button>
                        <b-button @click="deselectAll" variant="secondary">
                            <i class="fa-regular fa-square"></i>
                            {{ $t('deselect-all') }}
                        </b-button>
                    </b-button-group>
                </b-list-group-item>
            </b-list-group>

            <b-list-group
                v-for="resource in resources"
                v-bind:key="resource.id"
                class="mt-2">
                <div class="flex-column align-items-start">
                    <div class="list-group-item flex-column align-items-start list-group-item-action ps-0">
                        <div>
                            <div class="col-4 ms-1" v-if="resource.allow_edit && stateAllowed">
                                <b-form-checkbox
                                    switch
                                    size="lg"
                                    v-model="massSelections"
                                    v-bind:key="resource.id"
                                    name="checkbox"
                                    :value="{id: resource.id, name: resource.name, my_resource: resource.my_resource, is_expired: resource.is_expired}"
                                >
                                </b-form-checkbox>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small class="ms-2"><b>{{ $t('state') }}</b></small>
                                <small class="ms-2"><b>{{ $t('State expired') }}</b></small>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small>
                                    <span v-if="resource.status === 1">
                                        <span class="fa-stack font-xs">
                                            <i class="fa-solid fa-square fa-stack-2x text-success"></i>
                                            <i class="fa-solid fa-check fa-stack-1x fa-inverse"></i>
                                        </span>
                                    </span>
                                    <span v-if="resource.status === 2">
                                        <span class="fa-stack font-xs">
                                            <i class="fa-solid fa-square fa-stack-2x text-warning"></i>
                                            <i class="fa-regular fa-bell fa-stack-1x fa-inverse"></i>
                                        </span>
                                    </span>
                                    <span v-if="resource.status === 3">
                                        <span class="fa-stack font-xs">
                                            <i class="fa-solid fa-square fa-stack-2x text-danger"></i>
                                            <i class="fa-solid fa-exclamation fa-stack-1x fa-inverse"></i>
                                        </span>
                                    </span>
                                    <span
                                        v-if="resource.status !== 3 && resource.status !== 2 && resource.status !== 1">
                                        <span class="fa-stack font-xs">
                                            <i class="fa-solid fa-square fa-stack-2x text-primary"></i>
                                            <i class="fa-solid fa-question fa-stack-1x fa-inverse"></i>
                                        </span>
                                    </span>
                                </small>
                                <small>
                                    <span class="badge border border-danger text-danger"
                                          v-if="resource.is_expired">
                                        {{ $t('yes') }}
                                    </span>

                                    <span class="badge border border-success text-success"
                                          v-if="!resource.is_expired">
                                        {{ $t('no') }}
                                    </span>
                                </small>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small class="ms-2 col-4"><b>{{ $t('Name') }}</b></small>
                                <small class="text-end">
                                    {{ resource.name }}
                                    <span class="badge badge-pill border-info border text-primary"
                                          v-if="resource.my_resource" title="{{$t('My resource')}}">
                                        <i class="fa-solid fa-person-chalkboard"></i>
                                    </span>
                                </small>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small class="ms-2 col-4"><b>{{ $t('Resource group') }}</b></small>
                                <small class="text-end"
                                       v-if="permissions && permissions.scmmodule && permissions.scmmodule.resourcegroups && permissions.scmmodule.resourcegroups.index">
                                    <router-link
                                        class="link-underline link-underline-opacity-0"
                                        :to="{name: 'resourceGroupInfo', params: {id: resource.resourcegroup.id}}">
                                        {{ resource.resourcegroup.container.name }}
                                    </router-link>
                                </small>
                                <small v-else class="text-end">
                                    {{ resource.resourcegroup.container.name }}
                                </small>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small class="ms-2 col-4"><b>{{ $t('description') }}</b></small>
                                <small class="text-end">{{ resource.description }}</small>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small class="ms-2 col-4"><b>{{ $t('comment') }}</b></small>
                                <small class="text-end">{{ resource.comment }}</small>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small class="ms-2 col-4"><b>{{ $t('supervisor') }}</b></small>
                                <small class="text-end" v-if="resource.user">{{ resource.user.firstname }}
                                    {{ resource.user.lastname }}</small>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <small class="ms-2 col-4"><b>{{ $t('Last updated') }}</b></small>
                                <small class="text-end">{{ resource.human_last_updated }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </b-list-group>
            <b-list-group class="mt-3" ref="noMass">
                <div v-if="resources.length > 0">
                    <div class="d-flex w-100 justify-content-between">
                        <small>{{ $t('page') }} {{ paging.page }}</small>
                        <small>{{ $t('pagesize') }} {{ paging.limit }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-center mt-4">
                        <vue-awesome-paginate
                            :total-items="paging.count"
                            :items-per-page="25"
                            :max-pages-shown="5"
                            v-model="paging.page"
                            @click="getData"
                        />
                    </div>
                </div>
                <b-list-group-item v-if="resources.length === 0">
                    <h5 class="mb-1">{{ $t('noitems') }}</h5>
                </b-list-group-item>
            </b-list-group>
        </b-container>
    </div>
</template>
<script>
import { BFormCheckbox } from 'bootstrap-vue-next';
import { VueAwesomePaginate } from "vue-awesome-paginate";
import Multiselect from "vue-multiselect";
import { useToast } from 'vue-toastification';
import { debounce } from "../helpers";

export default {
    name: "ResourcesIndex",
    components: {BFormCheckbox, VueAwesomePaginate, Multiselect},
    data() {
        return {
            ready: true,
            listFilter: {
                filter: {
                    name: '',
                    description: '',
                    id: [],
                    resourcegroup_id: [],
                    status: []
                }
            },
            paging: {
                page: 1,
                pageCount: 1,
                count: 1
            },
            resources: [],
            settings: [],
            myResourceGroupIds: [],
            massSelections: [],
            selected: false,
            containNotAssignedObjects: false,
            state: 0,
            stateFilter: [],
            stateOptions: [
                {
                    label: this.$t('ok'),
                    value: 1
                },
                {
                    label: this.$t('warning'),
                    value: 2
                },
                {
                    label: this.$t('critical'),
                    value: 3
                }
            ],
            stateFilterOptions: [
                {
                    label: this.$t('unconfirmed'),
                    value: 0
                },
                {
                    label: this.$t('ok'),
                    value: 1
                },
                {
                    label: this.$t('warning'),
                    value: 2
                },
                {
                    label: this.$t('critical'),
                    value: 3
                }
            ],
            comment: null,
            error: {
                status: false,
                comment: false
            },
            collapseStateForm: false,
            permissions: {},
            toggleFilter: false
        }
    },
    mounted() {
        this.permissions = this.$store.state.permissions;
        this.resetFilter();
        if(this.$route.query.resources) {
            if(Array.isArray(this.$route.query.resources)) {
                this.listFilter.filter.id = this.$route.query.resources;
            } else {
                this.listFilter.filter.id = [this.$route.query.resources];
            }
        }
        if(this.$route.query.resourcegroups) {
            if(Array.isArray(this.$route.query.resourcegroups)) {
                this.listFilter.filter.resourcegroup_id = this.$route.query.resourcegroups;
            } else {
                this.listFilter.filter.resourcegroup_id = [this.$route.query.resourcegroups];
            }
        }
        if(this.$route.query.status) {
            if(Array.isArray(this.$route.query.status)) {
                this.listFilter.filter.status = this.$route.query.status;
            } else {
                this.listFilter.filter.status = [this.$route.query.status];
            }
        }
    },
    methods: {
        getData: function() {
            let loader = this.$loading.show();
            axios.post('/resources/index.json', {
                    filter: this.listFilter,
                    page: this.paging.page
                },
                {}
            ).then(result => {
                this.permissions = result.data.permissions;
                this.resources = result.data.resources.all_resources ?? [];
                this.settings = result.data.resources.settings ?? [];
                this.myResourceGroupIds = result.data.resources.myResourceGroupIds;
                this.paging = result.data.resources.paging ?? {
                    page: 1,
                    pageCount: 1
                };
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                loader.hide();
            });
        },
        goBack: function() {
            this.$router.push({name: 'dashboardsIndex'});
        },
        selectAll: function() {
            this.massSelections = this.resources.map(resource => {
                const o = {};
                o.id = resource.id;
                o.name = resource.name;
                o.my_resource = resource.my_resource;
                o.is_expired = resource.is_expired;
                return o;
            });
        },
        deselectAll: function() {
            this.massSelections = [];
        },
        reset: function() {
            this.deselectAll();
            this.resetFilter();
            this.stateFilter = [];
            this.error = {
                status: false,
                comment: false
            };
            this.status = 0;
            this.comment = null;
            //this.getData();
            this.$router.push({name: 'resourcesIndex'});
        },
        resetFilter: function() {
            this.listFilter = {
                filter: {
                    name: '',
                    description: '',
                    id: [],
                    status: []
                }
            }
        },

        toggleStateForm: function() {
            if(this.permissions.scmmodule && this.permissions.scmmodule.resources && this.permissions.scmmodule.resources.setstatus) {
                this.collapseStateForm = !this.collapseStateForm;
            }
        },

        toggleFilterForm: function() {
            this.toggleFilter = !this.toggleFilter;
        },

        setState: function() {
            if(this.state < 1) {
                this.error.status = true;
                return;
            }
            if(this.state.value > 1 && !this.comment) {
                this.error.comment = true;
                return;
            }
            let count = this.massSelections.length;
            let i = 0;
            this.massSelections.map(item => {

                axios.post('/resources/setState.json', {
                        id: item.id,
                        status: this.state.value,
                        comment: this.comment
                    },
                    {}
                ).then(result => {
                    i++;
                    if(i === count) {
                        this.collapseStateForm = !this.collapseStateForm;
                        this.getData();
                        this.deselectAll();
                        this.status = 0;
                        this.comment = null;
                        this.error = {
                            status: false,
                            comment: false
                        };
                    }

                }).catch(error => {
                    console.log(error);
                    const errorTxt = "error occured at saving state for item " + item.name;
                    useToast().error(errorTxt, {
                        timeout: 2000
                    });
                });

            });

            /*  this.collapseStateForm = !this.collapseStateForm;
              this.getData();
              this.deselectAll();
              this.status = 0;
              this.comment = null;
              this.error = {
                  status: false,
                  comment: false
              }; */
        }
    },
    watch: {
        massSelections: {
            handler: function(newVals) {
                this.containNotAssignedObjects = false;
                if(newVals.length > 0) {
                    this.selected = true;
                    newVals.map(selected => {
                        if(!selected.my_resource) {
                            this.containNotAssignedObjects = true;
                        }
                    });
                } else {
                    this.selected = false;
                }
            },
            deep: true
        },
        stateFilter: function(selection) {
            if(selection != null) {
                this.listFilter.filter.status = selection.map(obj => obj.value);
            }
        },

        listFilter: {
            handler: debounce(function() {
                this.currentPage = 1;
                this.getData();
            }, 500),
            deep: true
        }
    },
    computed: {
        stateAllowed: function() {
            return this.permissions.scmmodule && this.permissions.scmmodule.resources && this.permissions.scmmodule.resources.setstatus;
        }
    }

}
</script>


<style scoped>
div.required .control-label::after {
    content: ' *';
    color: red;
    display: inline;
}


</style>